import useSWR from 'swr';
import useOwnerOrgId from '@/lib/hooks/useOwnerOrgId';
import fetcher from '@/lib/swr/fetcher';
import type OpportunityStage from '@/types/api/OpportunityStage';
import joinNonEmptyParams from '@/utils/joinNonEmptyParams';

export default function useOpportunityStages(canFetch = true) {
  const ownerOrgId = useOwnerOrgId();
  const key = `opportunity-stages?${joinNonEmptyParams({
    ownerOrgId,
  })}`;

  return useSWR<{ opportunityStages: OpportunityStage[] } | undefined>(
    canFetch && key,
    fetcher,
  );
}
